import { render } from "./OidoCardFooter.vue?vue&type=template&id=36ae232a&scoped=true"
import script from "./OidoCardFooter.vue?vue&type=script&lang=js"
export * from "./OidoCardFooter.vue?vue&type=script&lang=js"

import "./OidoCardFooter.vue?vue&type=style&index=0&id=36ae232a&scoped=true&lang=css"
import "./OidoCardFooter.vue?vue&type=style&index=1&id=36ae232a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ae232a"]])

export default __exports__